import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		config: {
			social_media_links: [],
		},
		settings: {
			darkMode: false,
		},
		user: {},
		news: [],
		events: [],
		benefits: [],
		pages: [],
		notifyMessage: '',
		notifyError: '',
	},
	getters: {
		// Snackbar needs boolean for v-model
		showNotifyMessage: (state) => {
			return (state.notifyMessage && state.notifyMessage.length) ? true : false
		},

		// Snackbar needs boolean for v-model
		showNotifyError: (state) => {
			return (state.notifyError && state.notifyError.length) ? true : false
		}
	},
	mutations: {
		setConfig(state, payload) {
			state.config = Object.assign({}, payload)
		},

		setSettings(state, payload) {
			state.settings = Object.assign({}, payload)
		},

		setUser(state, payload) {
			state.user = payload
		},

		setNews(state, payload) {
			state.news = payload
		},

		setEvents(state, payload) {
			state.events = payload
		},

		setBenefits(state, payload) {
			state.benefits = payload
		},

		setPages(state, payload) {
			state.pages = payload
		},

		setNotifyMessage(state, payload) {
			state.notifyMessage = payload
		},

		setNotifyError(state, payload) {
			state.notifyError = payload
		},
	},
	actions: {
		clearData({ commit }) {
			return new Promise(resolve => {
				commit('setConfig', {})
				commit('setUser', {})
				commit('setNews', [])
				commit('setEvents', [])
				commit('setBenefits', [])
				commit('setPages', [])

				resolve()
			})
		},

		getSettings({ commit }) {
			return new Promise(resolve => {
				let settings = localStorage.getItem('settings') || '{}'

				commit('setSettings', JSON.parse(settings))

				resolve()
			})
		},

		setSettings({ commit }, payload) {
			commit('setSettings', payload)

			// Save to localstorage
			localStorage.setItem('settings', JSON.stringify(payload))
		},
	}
})
